module.exports = __webpack_public_path__ + "static/img/img-carousel-prop-1.fce65fb.png";